import React, { useMemo } from 'react';
import axios from 'axios';
import { motion } from 'framer-motion';
import { formatNull, formatDate } from '../../Utils/GlobalUtils';

import WarningPanel from '../WarningPanel';
import Loading from '../Loading';

import styles from '../../styles/DynamicModal.module.css';
import miniTable from '../../styles/MiniTables.module.css';

import IconContainer from '../../Components/IconContainer';
import { ReactComponent as XIcon } from '../../icons/x-close.svg';
import { ReactComponent as DotIcon } from '../../icons/dot.svg';
import { ReactComponent as CaretDownIcon } from '../../icons/caret-down.svg';
import { ReactComponent as CaretUpIcon } from '../../icons/caret-up.svg';

export default function FilterAMApplications({ field=null, filters, setFilters, DEFAULT_FILTERS, userId, closeModal }) {
    const [entries, setEntries] = React.useState([]);
    const [reload, setReload] = React.useState(true);
    const [warning, setWarning] = React.useState('');
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        const token = localStorage.getItem('token');

        axios.get(`/api/get-one-field-entries-in-am-applications?field=${field}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            params: {
                user_id: userId,
            }
        })
        .then(response => {
            setEntries(response.data);
            console.log(response.data);
        })
        .catch(error => {
            console.error('Ошибка при получении данных:', error);
            setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
        }).finally(() => {
            setLoading(false);
            setReload(false);
        })
    }, [reload]);

    const [searchNumber, setSearchNumber] = React.useState('');

    const filteredNumbers = useMemo(() => {
        const query = searchNumber.trim().toLowerCase();
        if (!query) return entries;

        return entries.filter(entry => {
            const fullEntry = `${entry.number}`.toLowerCase();
            return fullEntry.includes(query) || entry.number.toLowerCase().includes(query);
        });
    }, [entries, searchNumber]);

    const [searchDebtor, setSearchDebtor] = React.useState('');

    const filteredDebtors = useMemo(() => {
        const query = searchDebtor.trim().toLowerCase();
        if (!query) return entries;

        return entries.filter(entry => {
            const fullEntry = `${entry.name}`.toLowerCase();
            return fullEntry.includes(query) || entry.name.toLowerCase().includes(query);
        });
    }, [entries, searchDebtor]);

    const [searchCountPretenders, setSearchCountPretenders] = React.useState('');

    const filteredCountPretenders = useMemo(() => {
        const query = searchCountPretenders.trim();
        if (!query) return entries;

        return entries.filter(entry => {
            const fullEntry = `${entry.applications_count}`;
            return fullEntry.includes(query);
        });
    }, [entries, searchCountPretenders]);



    const allSelectedNumbers =
        filteredNumbers.length > 0 &&
        filteredNumbers.every(entry => filters.numbers.includes(entry.number));

    const handleSelectAllNumbers = () => {
        setFilters(prev => ({
            ...prev,
            numbers: allSelectedNumbers
                ? prev.numbers.filter(
                    number => !filteredNumbers.some(entry => entry.number === number)
                )
                : [
                    ...new Set([
                        ...prev.numbers,
                        ...filteredNumbers.map(entry => entry.number)
                    ])
                ]
        }));
    };


    const handleChange = (field) => (e) => {
        const value = e.target.value;

        setFilters((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    const addFilter = () => {
        closeModal();
    };

    const resetFilters = () => {
        setFilters(DEFAULT_FILTERS);
        closeModal();
    };

    const [isDateMailingOpen, setIsDateMailingOpen] = React.useState(false);


    return (
        <div className={styles.liningOver}>
            <motion.div
                className={styles.lining} 
                onClick={(e) => e.stopPropagation()}
                initial={{ scale: '97%', opacity: 0 }}
                animate={{ scale: '100%', opacity: 1 }}
                exit={{ scale: '97%', opacity: 0 }}
                transition={{ duration: 0.3 }}
            >
                <div className={styles.header}>
                    <h1>Фильтр по моим заявкам</h1>
                    <IconContainer Icon={XIcon} onClick={closeModal} size = '20' color = 'black' className = '' />
                </div>
                <div className={styles.main} style={{height: '70vh'}}>
                    {field=='numbers' &&
                    <>
                    <div className='labelInputWrapper'>
                        <div className='label'>
                            <a>Номер заявки</a>
                            <p 
                                style={{fontSize: '11px'}}
                                className={`aWithLink ${filters.numbers.length===0 && 'disabledTextButton'}`}
                                onClick={() => {
                                    setFilters((prev) => ({
                                        ...prev,
                                        numbers: [],
                                    }));
                                }}
                            >
                                Сбросить
                            </p>
                        </div>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <input 
                                    type='text' 
                                    value={searchNumber}
                                    onChange={(e) => setSearchNumber(e.target.value)}
                                    placeholder='Номер' 
                                    minLength='' 
                                    maxLength='100' 
                                    required 
                                />
                            </div>

                            {loading ? <Loading />
                            : warning ? <WarningPanel text={warning} />
                            :
                            <>
                            {!searchNumber && <p className='description'>Первые 400 записей</p>}
                            {filteredNumbers.length!==0 &&
                            <div className={miniTable.table}>
                                <div
                                    className={`${miniTable.line} ${miniTable.lineWithHover}`}
                                    style={{ gridTemplateColumns: '99fr 1fr' }}
                                    onClick={handleSelectAllNumbers}
                                >
                                    <div>
                                        Выбрать все {searchNumber && 'из показанных'}
                                    </div>
                                    <div className={miniTable.actions}>
                                        <input 
                                            type='checkbox'
                                            checked={allSelectedNumbers}
                                            readOnly={true}
                                        />
                                    </div>
                                </div>
                            </div>}
                            <div className={miniTable.table}>
                                {filteredNumbers.length===0 ? <WarningPanel text='Ничего не найдено' inTable={true} />
                                : filteredNumbers.map((entry, index) => (
                                    <div
                                        className={`${miniTable.line} ${miniTable.lineWithHover}`}
                                        key={index}
                                        style={{ gridTemplateColumns: '99fr 1fr' }}
                                        onClick={() => {
                                            setFilters(prev => ({
                                                ...prev,
                                                numbers: prev.numbers.includes(entry.number)
                                                    ? prev.numbers.filter(n => n !== entry.number)
                                                    : [...prev.numbers, entry.number]
                                            }));
                                        }}
                                    >
                                        <div>
                                            {formatNull(entry.number)}
                                        </div>
                                        <div className={miniTable.actions}>
                                            <input 
                                                type='checkbox'
                                                checked={filters.numbers.includes(entry.number)}
                                                readOnly={true}
                                            />
                                        </div>
                                    </div>
                                ))}
                            </div>
                            </>}
                        </div>
                    </div>
                    </>}
                </div>
                <div className={styles.bottom}>
                    {field!==null &&
                    <>
                    <div>Выберите параметры</div>
                    <div className='horizontalContainer'>
                        <button 
                            type='button' 
                            className='button optionalButton red' 
                            onClick={resetFilters}
                        >
                            Сбросить все фильтры
                        </button>
                        <button 
                            type='button' 
                            className='button' 
                            onClick={addFilter}
                        >
                            Применить фильтр
                        </button>
                    </div>
                    </>}
                </div>
            </motion.div>
        </div>
    )
}
